import { Flow } from 'signup-constants/Flow';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getFlowKey } from '../../routing/getFlowKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
import { setSignupDataValue } from '../../store/signup-data/action-creators';
import { Data } from '../../signup-data/DATA';
import { NextStepManager } from '../../flow-management/NextStepManager';
export const BranchACQ134VariantA = {
  name: 'BranchACQ134VariantA',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0134, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection
    } = getFlowSteps();
    const flowKey = getFlowKey();
    let postVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.CompanyInfo, Step.HubletSelection];

    if (flowKey !== Flow.Crm) {
      dispatch(setSignupDataValue(Data.HubOption, getFlowConfig().hubInterest));
      postVerificationSteps = NextStepManager.removeSteps(Step.HubOption)(postVerificationSteps);
    }

    const nextSteps = [...preVerification, ...postVerificationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, [], postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};